import { z } from 'zod';
import { uuidSchema, pageCursorSchema } from './common.js';
import { conditionBandSchema } from './asset.js';

export const transactionListItemSchema = z.object({
  id: uuidSchema,
  closedAt: z.string(),
  assetId: uuidSchema,
  assetSerial: z.string().nullable(),
  skuShortDescription: z.string().nullable(),
  sellerOrgId: uuidSchema,
  sellerLegalName: z.string(),
  buyerOrgId: uuidSchema,
  buyerLegalName: z.string(),
  salePriceUsd: z.string(),
  feesUsd: z.string().nullable(),
  netToSellerUsd: z.string().nullable(),
  conditionBand: z.string().nullable(),
  currencyCode: z.string(),
});
export type TransactionListItem = z.infer<typeof transactionListItemSchema>;

export const transactionListResponseSchema = z.object({
  data: z.array(transactionListItemSchema),
  nextCursor: pageCursorSchema.nullable(),
});
export type TransactionListResponse = z.infer<typeof transactionListResponseSchema>;

export const transactionCreateSchema = z.object({
  assetId: uuidSchema,
  buyerOrgId: uuidSchema,
  closedAt: z.string().datetime(),
  salePriceUsd: z.string(),
  feesUsd: z.string().optional(),
  conditionBand: conditionBandSchema,
  auctionId: z.string().optional(),
  listingId: z.string().optional(),
  notes: z.string().optional(),
});
export type TransactionCreate = z.infer<typeof transactionCreateSchema>;

export const transactionDetailSchema = transactionListItemSchema.extend({
  auctionId: z.string().nullable(),
  listingId: z.string().nullable(),
  notes: z.string().nullable(),
});
export type TransactionDetail = z.infer<typeof transactionDetailSchema>;
